// added by Samikchha Kumar on 25-Mar-2023

import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { CommonService } from 'src/app/Global-Services/common.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GlobalVariable } from 'src/app/Variable/global-variable';
@Component({
  selector: 'app-fteform',
  templateUrl: './fteform.component.html',
  styleUrls: ['./fteform.component.css'],
  providers: [CommonService],
  standalone: false,
})


export class FteformComponent implements OnInit {
  filteredEngSingle: any[] = [];
  IsNew: any;
  IsReview: any;
  count = 0;
  n: any;
  i: any;
  ID: '';
  EngCode: string[];
  boolReturn: any;
  ErrorMessage = [];
  formData: FormData = new FormData();
  SupportingAttachment: File;
  isDisabled: boolean = false;
  IsSLHR = false;
  IsCounsellor = false;
  IsPartner = false;
  Roles = [];
  EngCodeHistoryList: any[];
  IsExport: boolean;
  IsAdmin = false;
  IsBUOUSpoc = false;
  ParamID: any;
  CurrUserGPN = '';
  PageNumber = 1;

  EngCodeList = {
    TopRecord: 0,
    TotalRecord: 0,
    RecordFrom: 0,
    RecordTo: 0,
    TotalPageCount: 0,
    currentPage: 1,
    EngCode: null,
    EngTitle: null,
    CostAllocation: null,
    EngPartner: null,
    EngManager: null,
    UpdatedBy: null,
    UpdatedOn: null
  };

  FTERecord = {
    TopRecord: 0,
    TotalRecord: 0,
    RecordFrom: 0,
    RecordTo: 0,
    TotalPageCount: 0,
    currentPage: 1,
    Isdeleted: 0,
    EmpName: '',
    EmpGPN: '',
    EmpLPN: '',
    EmpJoiningDate: '',
    Entity: '',
    EmpLocation: '',
    EmpTitle: '',
    ServiceLine: '',
    EmpManagerGPN: '',
    EmpManagerName: '',
    EmpPartnerGPN: '',
    EmpPartnerName: '',
    CurrUserGPN: '',
    RequestStatusID: 0,
    RequestStatusDesc: '',
    EngagementCodeList: [],
    xyz: '',
    RequestID: 0,
    ID: '',
    EngCode: '',
    EngTitle: '',
    IsReviewed: 0,
    IsRecordActive: 0,
  };

  constructor(public route: ActivatedRoute, private confirmBox: ConfirmationService,
    public gService: CommonService, public datepipe: DatePipe, private gVariable: GlobalVariable,
    private appTokenHandler: AppTokenHandler, private _Location: Location, public dialog: MatDialog, private _router: Router,
    private el: ElementRef) {
  }


  ngOnInit() {
    this.IsNew = 1;
    this.gVariable.User = this.gService.getUserDetails('zero');
    this.ID = this.route.snapshot.params['ID'];
    this.FTERecord.CurrUserGPN = this.gVariable.User.UserGPN;
    this.Roles = this.gVariable.User._ApplicationRole.split(',');

    this.IsAdmin = this.Roles.indexOf('Admin1') > -1 ? true : false;
    this.IsBUOUSpoc = this.Roles.indexOf('BUOUSpoc') > -1 ? true : false;
    this.IsCounsellor = this.Roles.indexOf('IsCounsellor') > -1 ? true : false;
    this.IsPartner = this.Roles.indexOf('IsPartner') > -1 ? true : false;
    this.IsSLHR = this.Roles.indexOf('IsSLHR') > -1 ? true : false;
    const today = new Date();
    //Condition Date change from 28 to 25 for SCTASK5568463
    //Now condition has changes from 12 to 29 for SCTASK6007893
    if (today.getDate() > 29 || today.getDate() < 12) {
      this.isDisabled = true;
    }
    // else if (today.getDate() == 1) {
    //   this.isDisabled = false;
    //   this.FTERecord.IsReviewed = 0;
    // }
    else {
      this.isDisabled = false;
    }


    if (this.ID != null && this.ID !== '') {
      this.GetFTERecordsByID(this.ID, this.FTERecord.CurrUserGPN);
      this.GetEngCodeHistory(this.ID, this.FTERecord.CurrUserGPN);
    }

  }

  GetEngCodeHistory(ID: any, CurrUserGPN: string) {

    this.gService.GetEngCodeHistory(ID, CurrUserGPN, this.PageNumber, this.EngCodeList, this.IsAdmin).subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {

          this.EngCodeList.TopRecord = data[0]['TopRec'];
          this.EngCodeList.TotalRecord = data[0]['TotRec'];
          this.EngCodeList.RecordFrom = data[0]['RecordFrom'];
          this.EngCodeList.RecordTo = parseFloat(data[0]['RecordFrom']) + (data.length - 1);
          this.EngCodeList.TotalPageCount = data[0]['TotalPageCount'];
          this.EngCodeHistoryList = data;
        } else {
          this.EngCodeHistoryList = data;
          this.EngCodeList.TopRecord = 0;
          this.EngCodeList.TotalRecord = 0;
          this.EngCodeList.RecordFrom = 0;
          this.EngCodeList.RecordTo = 0;
          this.EngCodeList.TotalPageCount = 0;
          this.EngCodeList.currentPage = 1;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  UpdateEngagementCode(type: number) {

    // if(this.FTERecord.EngCode==this.EngCodeList.EngCode.ENGID){
    //   alert("Engagement ID is already present!");
    //   this.EngCodeList.EngCode=null;
    //   return;
    // }
    this.ErrorMessage = [];
    this.FTERecord.EngCode = this.EngCodeList.EngCode.ENGID;
    this.FTERecord.ID = this.ID;
    this.FTERecord.CurrUserGPN = this.FTERecord.CurrUserGPN == null ? this.gVariable.User.UserGPN : this.FTERecord.CurrUserGPN;
    if (this.ErrorMessage.length > 0) {
      return;
    }
    this.boolReturn = false;
    this.boolReturn = confirm('Please make sure the data updated is correct else in case of any error exceptional approval will be required from Neeraj Khetan.');
    if (this.boolReturn === false) {
      return;
    }
    if (this.FTERecord.Isdeleted == 1) {
      this.FTERecord.IsReviewed = 1;
    }
    this.gService.PostService(this.FTERecord, 'FTERecords/UpdateEngagementCode').subscribe(data => {
      if (type === 1) {
        alert("Engagement Code Submitted Successfully!");
        this._router.navigate(['View/FTERecords/1']);
      }
      else {
        alert("Engagement Code Reviewed Successfully!");
        this._router.navigate(['View/PendingForEngagementCodeReview/3']);
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetEngCodeSearch(event: any) {
    this.ErrorMessage = [];
    this.EngCode = [];
    const query = event.query.trim();
    if ((query.length) >= 3) {
      this.gService.GetEngCodeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        this.EngCode = [];
        this.EngCode = data;
        this.filteredEngSingle = this.filterFilterEngCode(query, this.EngCode);
      },
        (err: HttpErrorResponse) => {

          this.EngCode = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  OnClearEngCode() {
    this.EngCodeList.EngCode = '';
    this.EngCodeList.EngCode = null;
    this.EngCode = null;
  }

  SetSelectedEngCode(event: any) {
    this.EngCode = event.ENGID;
  }

  filterFilterEngCode(query: any, EngCodeList: any[]): any[] {
    const filtered: any[] = [];
    let len = 10;
    if (EngCodeList.length > 0) {
      // for (let i = 0; i < EngCodeList.length; i++) {
      if(EngCodeList.length <= 10)
        len = EngCodeList.length;
      else
      {
        len = 10;
      }
        for (let i = 0; i < len; i++) {
        const Emp = EngCodeList[i];
        if (Emp.ENGID.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
          filtered.push(Emp);
        }
      }
    }
    else {
      this.EngCodeList.EngCode = null;
      alert("Engagement ID is either closed or incorrect!")
    }
    return filtered;
  }

  SetTextValue(event, Type: any): void {

    const newVal = event.target.value;

  }

  GetFTERecordsByID(ID: any, CurrUserGPN: string) {

    this.gService.GetFTERecordsByID(ID, CurrUserGPN).subscribe((data: any) => {

      if (data != null) {
        this.FTERecord.ID = data.ID;
        this.FTERecord.EmpName = data.EmpName;
        this.FTERecord.EmpGPN = data.EmpGPN;
        this.FTERecord.EmpLPN = data.EmpLPN;
        this.FTERecord.EmpJoiningDate = data.EmpJoiningDate;
        this.FTERecord.Entity = data.Entity;
        this.FTERecord.EmpLocation = data.EmpLocation;
        this.FTERecord.EmpTitle = data.EmpTitle;
        this.FTERecord.ServiceLine = data.ServiceLine;
        this.FTERecord.EmpManagerGPN = data.EmpManagerGPN;
        this.FTERecord.EmpManagerName = data.EmpManagerName;
        this.FTERecord.EmpPartnerGPN = data.EmpPartnerGPN;
        this.FTERecord.EmpPartnerName = data.EmpPartnerName;
        this.FTERecord.RequestStatusID = data.RequestStatusID;
        this.FTERecord.RequestStatusDesc = data.RequestStatusDesc;
        this.FTERecord.Isdeleted = data.Isdeleted;
        this.FTERecord.EngCode = data.EngCode;
        this.FTERecord.EngTitle = data.EngTitle;
        this.FTERecord.IsReviewed = data.IsReviewed;
        this.FTERecord.IsRecordActive = data.IsRecordActive;
        this.FTERecord.EngagementCodeList = data.EngagementCodeList;
        this.filteredEngSingle = [
          {
            ENGID: data.EngCode,
          ENGTitle: data.EngTitle
          }
        ];
        // this.filteredEngSingle = {
        //   ENGID: data.EngCode,
        //   ENGTitle: data.EngTitle
        // }


        this.EngCodeList.EngCode = this.filteredEngSingle[0];

        if (this.FTERecord.Isdeleted == 1) {
          this.IsNew = 0;
        }
        if (this.FTERecord.IsReviewed == 1) {
          this.IsReview = 1;
          this.IsNew = 0;
        }

      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  onExit() {
    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to Exit?');
    if (this.boolReturn === false) {
      return;
    }
    this._Location.back();
  }
}
// END by Samikchha Kumar on 25-Mar-2023
